define(function(require) {
  // general
  const utils = require('civicsUtils/general_utilities');
  // templates
  const tpl = require('civicsViews/inspection_results/templates/t_itv_inspection_result_item.hbs');
  // views
  const InspectionRequestView = require('civicsViews/inspection_request/v_itv_inspection_request');
  const CancelInspectionRequestView = require('civicsViews/inspection_request/v_itv_inspection_cancel_request');
  const CommentsView = require('civicsViews/long_message_modal/v_lov_long_message_modal');
  const ViewManager = require('civicsUtils/view_manager');
  const InspectionModel = require('civicsModels/inspection_model');
  const InstrumentUtils = require('civicsUtils/instrument_utilities');
  const code_definition_collection = require('civicsCollections/code_definition_collection');

	//utilities
	const AvailableFeatures = require('civicsUtils/available_features');

  const general_utilities = require('civicsUtils/general_utilities');
  const inspection_review_button_functions = require('civicsUtils/inspection_review_button_functions');

  const action_view = require('civicsViews/inspection_results/action/v_cpv_inspection_actions');

  return Marionette.LayoutView.extend({
    tagName: 'div',
    className: 'list-row',
    attributes: {
      'role': 'row'
    },
    template: tpl,
    events: {
      'click @ui.btnInspectionRequest': 'inspectionRequestClicked',
      'click @ui.btnCancelRequest': 'cancelRequestClicked',
      'click @ui.btnShowComment': 'viewCommentsClicked'
    },
    ui: {
      btnInspectionRequest: '.btn-inspection-request',
      btnCancelRequest:'.btn-cancel-request',
      actionRegion: '.action-region',
      btnShowComment: '.view-comments'
    },
    regions: {
      actionRegion: '.action-region'
    },
    initialize: function(options) {
      this.needsActionGrid = options.needsActionGrid;
      this.config = options.config;
      this.modalRegion = options.modalRegion;
      this.assignmentType = 'inspection';

      this.instrumentModel = options.instrumentModel;
      this.usesProviderView = options.usesProviderView;
      this.isProvider = this.usesProviderView && (ViewManager.currentUser().get('contactId.id') == this.model.get('assignedToProvider')?.get('id'));
      this.instrumentDetailView = true;

      this.instrumentType = InstrumentUtils.camelify(this.config.fromServer.instrumentType);
      this.config.usesBackOfficeConfiguration = AvailableFeatures.hasFeature("SPC");
      this.logTypes = {
        cancelInspection: this.config.globalConfig[this.instrumentType].cancelInspectionLogType,
        declineInspection: this.config.globalConfig[this.instrumentType].declineInspectionLogType

      }

    },
    onRender: function() {
      this.$el.rhythmThemeInitCivics();
    },
    onShow: function() {


        if(this.isProvider) {
          this.model.set('_cdrType',this.instrumentType);
          this.model.set('_dataType',this.instrumentType+'Inspection');
          this.model.set('_assignmentType','inspection');
          this.model.set('instrument', this.instrumentModel);

          this.determineProviderButtons();
          var buttons = this.getProviderButtonData();


          this.actionView = new action_view({
            config: this.config,
            modalRegion: this.modalRegion,
            data: buttons,
            collection: new Backbone.Collection(buttons)
          });
          this.addRegion('actionRegion','.action-region');
          this.getRegion('actionRegion').show(this.actionView);
        }

    },
    determineProviderButtons: function(e) {
      var hasScheduledDate, hasResult, hasRequestDate = false;
			var scheduledDate = this.model.get('scheduledDateTime');
			hasScheduledDate = general_utilities.dateExists(scheduledDate);
			hasResult = this.model.get('result').trim() != '';

      var notResulted = i18n.t('CIVICS.INSTRUMENT_DETAIL.NOT_YET_RESULTED');
      var requestDate = this.model.get('scheduledDateTime');

      if (this.config.captureRequestDateToCallDate){
        requestDate = this.model.get('callDateTime');
      }

      hasRequestDate = general_utilities.dateExists(requestDate);
      //scenario 1: Has a result
      if (hasResult) {

        this.actionButtons = this.inspectionButtons.hasResult;
      } else if (hasScheduledDate) {//and no result

        this.actionButtons = this.inspectionButtons.hasScheduledDate
      } else if (hasRequestDate) {//and no schedule date / result

        this.actionButtons = this.inspectionButtons.hasRequestDate;
      } else {//no requestDate, no scheduledate, no result

        this.actionButtons = this.inspectionButtons.hasNothing;
      }
    },
    getProviderButtonData: function(e) {
      if (this.actionButtons.length > 0) {
        var data = [];
        $.each(this.actionButtons, (index, action) => {
          if (action.viewDetails) {
            var url;

              var link = this.config.inspectionDetailsLink;
              url = link.urlPath({ inspdetails: this.instrumentType, inspid: this.model.get('id') });


            data.push({
              isLink: true,
              url: url,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.GRIDS.VIEW_DETAILS'),
              priority: 'secondary' //FIX THIS - should be primary based on some condition. see mockup
            });
          } else if (action.recordResults && this.canPerformAction()) {
            App.sessionStorage.set('CIVICS', 'PREV_PAGE', document.URL.urlPath().toString());

            var link = this.config.recordResultsPage;
            var params = { type: this.instrumentType, id: this.model.get('id') };

            var url = link.urlPath(params);

            var text = i18n.t('CIVICS.INSTRUMENT_DETAIL.RECORD_RESULTS');
            if (this.model.get('isRecordingStarted') === true) {
              text = i18n.t('CIVICS.INSTRUMENT_DETAIL.FINISH_RESULTS');
            }
            data.push({
              isLink: true,
              url: url,
              text: text,
              priority: 'secondary'
            });
          } else if (action.reschedule && this.canPerformAction()) {
            data.push({
              isButton: true,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.RESCHEDULE'),
              priority: 'secondary',
              callback: this.rescheduleAssignmentClicked.bind(this)
            });
          } else if (action.cancel && this.canPerformAction()) {
            data.push({
              isButton: true,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.CANCEL'),
              priority: 'secondary',
              callback: this.cancelAssignmentClicked.bind(this)
            });
          } else if (action.accept && this.canPerformAction()) {
            data.push({
              isButton: true,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.ACCEPT'),
              priority: 'secondary',
              callback: this.acceptAssignmentClicked.bind(this)
            });
          }
          else if (action.decline && this.canPerformAction()) {
            data.push({
              isButton: true,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.DECLINE'),
              priority: 'secondary',
              callback: this.declineAssignmentClicked.bind(this)
            });
          }
          else if (action.openElectronicPlan && (this.model.has('ElectronicPlanReviewURL')) && this.assignmentType == 'review') {
            data.push({
              isButton: true,
              text: i18n.t('CIVICS.INSTRUMENT_DETAIL.OPEN_ELECTRONICPLANS'),
              priority: 'secondary',
              callback: this.openElectronicPlanClicked.bind(this)
            });
          }
        });

        //first button should be primary
        data[0].priority = 'primary';

        return data;
      }
      return null;
    },
    canPerformAction: function() {
      if (this.instrumentModel.get("applicationIsClosedInPortal") == undefined) {
        return true;
      }

      return !this.instrumentModel.get("applicationIsClosedInPortal");
    },
    inspectionRequestClicked: function(e) {
      if (__DEV__) console.log('instrument detail - inspection item -- inspectionRequestClicked function');
      ViewManager.loading(true);
      $.when(this.fetchTimePreference()).done(()=>{
        this.inspectionRequestView = new InspectionRequestView({
          config: this.config,
          modalRegion: this.modalRegion,
          model: this.model,
          parentView: this
        })
        ViewManager.subscribe(this.inspectionRequestView, 'InstrumentDetailChannel');
        ViewManager.loading(false);
        this.modalRegion.show(this.inspectionRequestView);
        this.modalRegion.showModal();
      });
      return false;
    },
    fetchTimePreference: function(){
      let timePreferencesFetch = $.Deferred();
      if(!this.config.timePreferencesCollection){
          this.config.timePreferencesCollection = new code_definition_collection();
          this.config.timePreferencesCollection.moniker = 'Hansen.CDR.' + this.config.fromServer.instrumentType + '.TimePreference';
          this.config.timePreferencesCollection.fetch({
            success:()=> {
              timePreferencesFetch.resolve();
            }
          });
      }else{
        timePreferencesFetch.resolve();
      }
      return timePreferencesFetch;
    },  
    cancelRequestClicked: function (e) {
          if(__DEV__) console.log('instrument detail - inspection item -- cancelRequestClicked function');

          var inspectionModel = new InspectionModel();
          inspectionModel.set('id', this.model.get('id'));
          inspectionModel.set('callDateTime', this.model.get('callDateTime'));
          inspectionModel.set('scheduledDateTime', this.model.get('scheduledDateTime'));
          inspectionModel.set('timePreference', this.model.get('timePreference'));
          inspectionModel.set('inspectionType', this.model.get('inspectionType'));
          inspectionModel.set('inspectionTypeNumber', this.model.get('inspectionTypeNumber'));
          inspectionModel.set('location', this.model.get('location'));
          inspectionModel.formatUrlRoot(this.config.fromServer.instrumentType);

    			var cancelInspectionRequestView = new CancelInspectionRequestView({
            config: this.config,
    				model: inspectionModel,
    				modalRegion: this.modalRegion,
            parentView: this
    			})
          ViewManager.subscribe(cancelInspectionRequestView, 'InstrumentDetailChannel');
    			this.modalRegion.show(cancelInspectionRequestView);
    			this.modalRegion.showModal();
          return false;
    		},
        cancelInspectionRequestConfirmation: function () {
          this.render();
    		},
        requestCancelled: function (data) {
            // Called by the Cancel Inspection Request modal
            if(__DEV__) console.log('instrument detail - inspection item -- requestCancelled');
            this.model.set(data);
            this.render();
        },
    inspectionRequested: function(data) {
      // Called by the Inspection Request modal
      if (__DEV__) console.log('instrument detail - inspection item -- inspectionRequested');
      this.model.set(data);
      this.render();
    },
    isScheduled: function() {
      var requestDate = this.config.captureRequestDateToCallDate ? this.model.get('callDateTime') : this.model.get('scheduledDateTime');

      //applied the same constraint in Inspection Request modal requestdate is optional when this.hasServiceProviders() is true
      //scheduled should be true once there's an assigned provider and the requestdate is optional
      var hasAssignedServiceProvider = (this.hasServiceProviders() && this.model.get('assignedToProvider').get('id') > 1);
      if (requestDate && (utils.dateExists(requestDate) || hasAssignedServiceProvider)) {
        return true;
      }
      return false;
    },
    hasServiceProviders: function() {
      if(AvailableFeatures.FetchServiceProviderOnSingleRecord()) {
          return this.model.get('HasServiceProviders') ? this.model.get('HasServiceProviders') : false;
      }
      else{
        return this.model.get('serviceProviders') && this.model.get('serviceProviders').length > 0 ? true : false;
      }
    },
    viewCommentsClicked: function() {
      var commentsView = new CommentsView({
        title: i18n.t('CIVICS.INSTRUMENT_DETAIL.GRIDS.REVIEW_COMMENTS'),
        text: this.model.get("comments")
      })
      this.modalRegion.show(commentsView);
      this.modalRegion.showModal();
    },
    templateHelpers: function() {
      var self = this;
      let isScheduled = this.isScheduled();
      let isInspectionComplete = this.model.get('completed');
      let hasComment = this.model.get('comments') && this.model.get('comments').length > 0;
      let viewCommentsConfigEnabled = false;
      if (this.config.usesBackOfficeConfiguration && this.config.viewOptions) {
        viewCommentsConfigEnabled = this.config.viewOptions.showInspectionComments;
      }

      return {
        idLabel: i18n.t('CIVICS.COMMON.ID'),
        inspectionComplete: isInspectionComplete,
        inspectionLink: this.config.inspectionDetailsLink.urlPath({
          //  /#inspdetails/Planning/inspId/1001
          // inspdetails:this.config.fromServer.instrumentType+'|'+this.model.get('id')
          inspdetails: this.config.fromServer.instrumentType,
          inspid: this.model.get('id')
        }),
        isCustomer: this.config.isOwner === true,
        showRequestDateField: self.config.globalConfig.usesInspectionRequestDate != "Hide",
        needsActionGrid: self.needsActionGrid,
        scheduled: isScheduled,
        resultDescription: function() {
          return self.model.get('resultDescription');
        },
        formatDateString: function(date) {
          var dateString = Handlebars.helpers["global:formatDate"](date);
          if (dateString.length > 0) {
            return dateString;
          } else {
            return '<span class="no-data">-</span>';
          }
        },
        hasServiceProviders: this.hasServiceProviders(),
        rescheduleButton: ()=> {
          if (!this.config.closed && !isInspectionComplete && isScheduled) {
            if(this.config.useBackOfficeInspectionConfig){
              if(this.config.viewOptions.scheduling)
                return true;
            }else{
              if (this.config.isCustomer || this.config.publicInspectionRequest) {
                return true;
              }
            }
          }
          return false;
        },
        requestInspectionButton: ()=> {
          if (!this.config.closed && !isInspectionComplete && !isScheduled) {
            if(this.config.useBackOfficeInspectionConfig){
              if(this.config.viewOptions.scheduling)
                return true;
            }else{
              if (this.config.isCustomer || this.config.publicInspectionRequest) {
                return true;
              }
            }
          }
          return false;
        },
        viewDetailsButton: function() {
          return (!this.rescheduleButton() && !this.requestInspectionButton());
        },
        showButtons: function() {
          return (this.rescheduleButton() || this.requestInspectionButton() || this.viewDetailsButton());
        },
        showProviderButtons: this.isProvider,
        buttons: function() {
          var rtn = {
            reschedule: false,
            requestInspection: false,
            reviewDetails: false
          };
          if (this.isCustomer) {
            if (this.scheduled()) {
              rtn.reschedule = true;
            } else {
              rtn.requestInspection = true;
            }
          } else {
            rtn.reviewDetails = true;
          }

          return rtn;
        },
        viewName: self.viewName == null ? '' : self.viewName,
        showComments: this.config.isCustomer && viewCommentsConfigEnabled && hasComment,
        viewComments: i18n.t('CIVICS.INSTRUMENT_DETAIL.GRIDS.VIEW_COMMENTS')
      }
    }
  }).extend(inspection_review_button_functions);
});
